import React from 'react';
import { MdMicNone, MdMic } from "react-icons/md";
import { SlControlPlay } from "react-icons/sl";

export const RecordingSection = ({
  isgranted,
  recordingStatus,
  buttonState,
  duration,
  recordRef,
  pulseRef,
  onStartRecording,
  onStopRecording,
  onPlayback,
  onEnableMicrophone
}) => {
  if (!isgranted) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200/50">
        <div className="text-2xl mb-2">🎤</div>
        <p className="text-amber-700 text-center text-sm font-medium">Enable microphone</p>
        <button 
          className="px-3 py-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white rounded transition-all duration-300 font-medium flex items-center gap-1 text-sm mt-1 shadow-lg shadow-amber-500/25"
          onClick={onEnableMicrophone} 
          type="button"
        >
          <MdMic className="text-base" />
          Enable
        </button>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col justify-center">
      <div className='flex flex-col items-center gap-4 max-w-md mx-auto w-full'>  
        {/* Mic and Progress Bar - Dynamic states */}
        <div className='flex items-center gap-3 w-full'>
          <div className="text-gray-600 flex-shrink-0">
            {recordingStatus === 'inactive' ? 
              <div className="p-2 bg-white/60 rounded-xl border border-white/40">
                <MdMicNone className="text-xl"/> 
              </div>
              : 
              <div ref={pulseRef} className="p-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl shadow-lg shadow-green-500/25 animate-pulse">
                <MdMic className="text-xl text-white" />
              </div>
            }
          </div>
          <div className={`relative w-full h-2 rounded-full border overflow-hidden flex-1 transition-all duration-300 ${
            recordingStatus === 'recording' 
              ? "bg-blue-100 border-blue-200/50" 
              : "bg-gray-100 border-gray-200/50"
          }`}>
            <div 
              className={`absolute left-0 top-0 h-full transition-all duration-100 ${
                recordingStatus === 'recording' 
                  ? "bg-gradient-to-r from-blue-500 to-indigo-500" 
                  : "bg-gray-300"
              }`}
              style={{ 
                width: recordingStatus === 'recording' ? '100%' : '0%',
                transition: recordingStatus === 'recording' ? `width ${3*duration}s linear` : 'width 0.3s ease'
              }}
            ></div>
            <button 
              className={`absolute left-0 top-0 rounded-full w-4 h-4 shadow-lg -mt-1 transition-all duration-100 ${
                recordingStatus === 'recording' 
                  ? "bg-gradient-to-r from-blue-600 to-indigo-600" 
                  : "bg-gray-400"
              }`}
              ref={recordRef}
              style={{ 
                left: recordingStatus === 'recording' ? '100%' : '0%',
                transform: recordingStatus === 'recording' ? 'translateX(-100%)' : 'translateX(0)',
                transition: recordingStatus === 'recording' ? `left ${3*duration}s linear` : 'left 0.3s ease'
              }}
            ></button>
          </div>
        </div>

        {/* Recording Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 w-full justify-center">
          {recordingStatus === 'inactive' ? 
            <button 
              className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors font-medium flex items-center gap-2 justify-center flex-1 max-w-40 shadow-lg shadow-green-500/25"
              onClick={onStartRecording}
            >
              <MdMic className="text-base" />
              <span>Repeat</span>
              <span className="text-xs opacity-70">(R)</span>
            </button>
          : 
            <button 
              className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors font-medium flex items-center gap-2 justify-center flex-1 max-w-40 shadow-lg shadow-red-500/25"
              onClick={onStopRecording}
            >
              <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
              <span>Stop</span>
              <span className="text-xs opacity-70">(S)</span>
            </button>
          }
          
          <button 
            disabled={buttonState} 
            className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2 justify-center flex-1 max-w-40 ${
              buttonState 
                ? "bg-gray-300 text-gray-500 cursor-not-allowed border border-gray-300/40" 
                : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40"
            }`}
            onClick={onPlayback}
          >
            <SlControlPlay className="text-xs" />
            <span>Playback</span>
            <span className="text-xs opacity-70">(P)</span>
          </button>
        </div>
      </div>
    </div>
  );
};